import React from 'react';
import loadingIcon from '@src/assets/loading-light.png';
import styles from './index.module.less';

export enum ListStatus {
  NO_MORE = 'no_more',
  LOADING = 'loading',
  ERROR = 'error',
  EMPTY = 'empty',
  NONE = 'none',
}

export const ListStatusComponent: React.FC<{
  status: ListStatus;
  onRetry: () => void;
}> = ({ status, onRetry }) => {
  switch (status) {
    case ListStatus.LOADING:
      return (
        <div className={styles.loadingWrapper}>
          <img src={loadingIcon} alt="loading" className={styles.loadingIcon} />
        </div>
      );
    case ListStatus.ERROR:
      return (
        <div className={styles.loadingWrapper}>
          <span>加载失败，</span>
          <span className={styles.retryBtn} onClick={onRetry}>
            点击重试
          </span>
        </div>
      );
    case ListStatus.NO_MORE:
      return null;
    case ListStatus.EMPTY:
      return null;
  }
};
